import React from 'react';

const Edit = ({ width = 24, height = 25, fill = "#99439D", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1762_6600)">
      <path
        d="M1 19.1739V22.889C1 23.2311 1.26885 23.5 1.61103 23.5H5.32607C5.48493 23.5 5.6438 23.4389 5.75378 23.3167L19.0986 9.9841L14.5159 5.4014L1.18331 18.734C1.0611 18.8562 1 19.0028 1 19.1739ZM22.6425 6.44015C23.1191 5.96355 23.1191 5.19365 22.6425 4.71705L19.7829 1.85745C19.3063 1.38085 18.5365 1.38085 18.0599 1.85745L15.8235 4.09381L20.4062 8.6765L22.6425 6.44015Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_1762_6600">
        <rect width={width} height={height} fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default Edit;